<template>
    <div class="">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="基础信息" name="step1">
                <el-form :model="account" label-width="200px" :rules="rules" ref="companyForm" class="supplier-form">
                    <el-form-item label="业务对接人：" prop="fcallname">
                        <el-input type="text" v-model.trim="account.fcallname" auto-complete="off" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="业务对接人身份证：" prop="personInChangeNo">
                        <el-input type="text" v-model="account.personInChangeNo" auto-complete="off" :maxlength="18"></el-input>
                    </el-form-item>
                    <!--<el-form-item label="公司类型：" prop="fsuppliertypeid">
                        <el-cascader @change="selectCompanyType" ref="companyTyper" v-model="typeArray"
                                     placeholder="输入搜索" expand-trigger="hover"
                                     :options="companyTypes"
                                     filterable change-on-select
                        ></el-cascader>
                    </el-form-item>-->
                    <el-form-item label="成立日期：" prop="fbuilddate">
                        <el-date-picker default-value="2010-01-01" v-model="account.fbuilddate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd hh:mm:ss"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="法人代表：" prop="fenterprisemaster">
                        <el-input type="text" v-model="account.fenterprisemaster" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="法人代表身份证：" prop="fenterprisemasterid">
                        <el-input type="text" v-model="account.fenterprisemasterid" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="统一社会信用代码：" prop="fbusinessnum">
                        <el-input type="text" v-model="account.fbusinessnum" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="公司地址：" required>
                        <el-col :span="10">
                            <el-form-item prop="fprovinceid">
                                <el-select v-model="account.fprovinceid" placeholder="请选择" style="float:left">
                                    <el-option
                                        v-for="item in provinces"
                                        :key="item.fid"
                                        :label="item.fnameL2"
                                        :value="item.fid">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="2">省</el-col>
                        <el-col :span="10">
                            <el-form-item prop="fcityid">
                                <el-select v-model="account.fcityid" placeholder="请选择">
                                    <el-option v-for="item in cities"
                                               :key="item.fid"
                                               :label="item.fnameL2"
                                               :value="item.fid">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="2">市</el-col>
                    </el-form-item>
                    <el-form-item label="公司注册地址：" prop="cfcompanyaddres">
                        <el-input type="text" v-model="account.cfcompanyaddres" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="公司办公地址：" prop="faddress">
                        <el-input type="text" v-model="account.faddress" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="公司电话：" prop="flinkphone">
                        <el-input type="text" v-model="account.flinkphone" auto-complete="off" :maxlength="20"></el-input>
                    </el-form-item>
                    <el-form-item label="邮政编码：" prop="fpostnumber">
                        <el-input type="text" v-model="account.fpostnumber" auto-complete="off" :maxlength="6"></el-input>
                    </el-form-item>
                    <el-form-item label="纳税人身份：" prop="ftaxpayertype">
                        <el-select v-model="account.ftaxpayertype" placeholder="请选择" style="float:left">
                            <el-option
                                v-for="(name,index) in taxpayerTypes"
                                :key="index+1"
                                :label="name"
                                :value="index+1+''">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="国税登记号：" prop="fcentraltaxno">
                        <el-input type="text" v-model="account.fcentraltaxno" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="地税登记号：" prop="flandtaxno">
                        <el-input type="text" v-model="account.flandtaxno" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="注册资金（万元）：" prop="fregistermoney">
                        <el-input type="text" v-model="account.fregistermoney" auto-complete="off"></el-input>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
            <el-tab-pane label="上传承诺函" name="step2">
                <table border strip class="info-table">
                    <tr>
                        <th style="width: 30%">类型</th>
                        <th style="width: 70%"><b>*</b>承诺函文件名称</th>
                    </tr>
                    <tr>
                        <td>使用承诺函</td>
                        <td>
                            <div v-for="file in gysfjs" :key="file.id">
                                <a v-if="file.sort == 1"
                                :href="'/rest/file/down?fileName=' + file.fileName + '&fileOldName=' + encodeURIComponent(file.fileOldName)">
                                    {{file.fileOldName}}
                                </a>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>投标承诺函</td>
                        <td>
                            <div v-for="file in gysfjs" :key="file.id">
                                <a v-if="file.sort == 2"
                                :href="'/rest/file/down?fileName=' + file.fileName + '&fileOldName=' + encodeURIComponent(file.fileOldName)">
                                    {{file.fileOldName}}
                                </a>
                            </div>
                        </td>
                    </tr>
                </table>
                <div class="splitter"></div>
                <div>
                    <el-button icon="el-icon-plus" @click="addGysfj(1)">使用承诺函</el-button>
                    <div style="display: inline-block;margin-left: 20px; font-size: 14px;">模版下载：<a :href="utilBaseUrl +'pc/static/registrationLetter.docx'" target="_blank" style="color:#F28619;">《大华供应商门户注册及使用承诺函》模板</a></div>
                </div>
                <div class="splitter"></div>
                <div>
                    <el-button icon="el-icon-plus" @click="addGysfj(2)">投标承诺函</el-button>
                    <div style="display: inline-block;margin-left: 20px; font-size: 14px;">模版下载：<a :href="utilBaseUrl +'pc/static/inviteLetter.doc'" target="_blank" style="color:#F28619;">《大华供应商门户投标承诺函》模板</a></div>
                </div>

                <el-dialog title="上传承诺函" :visible.sync="gysfjVisible">
                    <el-form :model="gysfj" label-width="100px" :rules="rulesGysfj" ref="gysfjForm"
                             class="supplier-form">
                        <el-form-item label="附件：" prop="baseFiles">
                            <el-upload class="upload" ref="fileup"
                                       :action="uploadApi"
                                       :on-success="handleChangeGysfj"
                                       :on-error="uploadError"
                                       :on-preview="handlePreview"
                                       :on-remove="handleRemoveGysfj"
                                       :before-remove="beforeRemove"
                                       :before-upload="beforeUpload"
                                       :multiple="false"
                                       :limit="1"
                                       :on-exceed="handleExceed1">
                                <el-button size="small" type="primary">点击上传</el-button>
                                <div slot="tip" class="el-upload__tip">上传附件大小请不要超过100M。<br>
                                    <span class="redTip">注意：附件上传出现绿色打勾标志，才表示上传成功。</span></div>
                            </el-upload>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="gysfjVisible = false">取 消</el-button>
                        <el-button type="primary" @click="submitGysfj">确 定</el-button>
                    </div>
                </el-dialog>
            </el-tab-pane>
            <el-tab-pane label="联系人信息" name="step3">
                <table border strip class="info-table">
                    <tr>
                        <th>序号</th>
                        <th><b>*</b>姓名</th>
                        <th><b>*</b>身份证</th>
                        <th><b>*</b>类型</th>
                        <th>职务</th>
                        <th><b>*</b>手机</th>
                        <th>办公电话</th>
                        <th><b>*</b>邮箱</th>
                        <th>操作</th>
                    </tr>
                    <tr v-for="c, i in linkpersons">
                        <td>{{i+1}}</td>
                        <td>{{c.fpersonname}}</td>
                        <td>{{c.idCard}}</td>
                        <td>{{contactTypes[c.personType]}}</td>
                        <td>{{c.fposition}}</td>
                        <td>{{c.fphone}}</td>
                        <td>{{c.fworkphone}}</td>
                        <td>{{c.femail}}</td>
                        <td><a @click.prevent="contactEdit(i)" class="edit-btn" v-if="i">编辑</a><a v-if="i>1"
                                                                                                  @click.prevent="contactRemove(i)"
                                                                                                  class="delete-btn">删除</a>
                        </td>
                    </tr>
                    <tr v-if="!linkpersons.length">
                        <td colspan=9>暂无数据</td>
                    </tr>
                </table>
                <div class="splitter"></div>
                <el-button icon="el-icon-plus" @click="contactAdd" class="">新增</el-button>
                <el-dialog :title="isNaN(editIndex)?'新增联系人':'编辑联系人'" :visible.sync="contactFormVisible">
                    <el-form :model="contact" label-width="100px" :rules="rulesContact" ref="contactForm"
                             class="supplier-form">
                        <el-form-item label="姓名：" prop="fpersonname">
                            <el-input type="text" v-model.trim="contact.fpersonname" auto-complete="off"
                                      :disabled="editIndex===0"></el-input>
                        </el-form-item>
                        <el-form-item label="身份证：" prop="idCard">
                            <el-input type="text" v-model="contact.idCard" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="类型：" prop="personType">
                            <el-select v-if="linkpersons.length===1" v-model="contact.personType"
                                       :placeholder="contactTypes[1]" style="float:left" ref="personType"
                                       :disabled="true">
                                <el-option :key="'1'" :value="'1'" :label="contactTypes[1]"></el-option>
                            </el-select>
                            <el-select v-else v-model="contact.personType" placeholder="请选择" style="float:left"
                                       ref="personType" :disabled="editIndex==1">
                                <el-option
                                    v-for="type,i in contactTypes.slice(1)"
                                    :key="i+1+''"
                                    :label="type"
                                    :value="i+1+''">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="职务：" prop="fposition">
                            <el-input type="text" v-model="contact.fposition" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="手机：" prop="fphone">
                            <el-input type="text" v-model="contact.fphone" auto-complete="off" :maxlength="11"
                                      :disabled="editIndex<1"></el-input>
                        </el-form-item>
                        <el-form-item label="办公电话：" prop="fworkphone">
                            <el-input type="text" v-model="contact.fworkphone" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="备注：" prop="remark">
                            <el-input type="text" v-model="contact.remark" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="邮箱：" prop="femail">
                            <el-input type="text" v-model="contact.femail" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="contactFormVisible = false">取 消</el-button>
                        <el-button type="primary" @click="submitContact">确 定</el-button>
                    </div>
                </el-dialog>
            </el-tab-pane>
            <!--<el-tab-pane label="服务区域" name="step4">-->
            <!--<table border strip class="info-table">-->
            <!--<tr>-->
            <!--<th>序号</th>-->
            <!--<th><b>*</b>省</th>-->
            <!--<th>市</th>-->
            <!--<th>备注</th>-->
            <!--<th>操作</th>-->
            <!--</tr>-->
            <!--<tr v-for="a, i in serviceas">-->
            <!--<td>{{i+1}}</td>-->
            <!--<td>{{a.province}}</td>-->
            <!--<td>{{a.city}}</td>-->
            <!--<td>{{a.cfremark}}</td>-->
            <!--<td><a @click.prevent="areaEdit(i)" class="edit-btn">编辑</a><a @click.prevent="areaRemove(i)" class="delete-btn">删除</a></td>-->
            <!--</tr>-->
            <!--<tr v-if="!serviceas.length"><td colspan=5>暂无数据</td></tr>-->
            <!--</table>-->
            <!--<div class="splitter"></div>-->
            <!--<el-button icon="el-icon-plus" @click="areaAdd">新增</el-button>-->
            <!--<el-dialog :title="isNaN(editIndex)?'新增服务区域':'编辑服务区域'" :visible.sync="areaFormVisible">-->
            <!--<el-form :model="area" label-width="100px" :rules="rulesArea" ref="areaForm" class="supplier-form">-->
            <!--<el-form-item label="省：" prop="cfprovinceid">-->
            <!--<el-select v-model="area.cfprovinceid" placeholder="请选择" style="float:left">-->
            <!--<el-option-->
            <!--v-for="item in provinces"-->
            <!--:key="item.fid"-->
            <!--:label="item.fnameL2"-->
            <!--:value="item.fid">-->
            <!--</el-option>-->
            <!--</el-select>-->
            <!--</el-form-item>-->
            <!--<el-form-item label="市：" prop="cfcityid">-->
            <!--<el-select v-model="area.cfcityid" placeholder="请选择" style="float:left">-->
            <!--<el-option-->
            <!--v-for="item in cities"-->
            <!--:key="item.fid"-->
            <!--:label="item.fnameL2"-->
            <!--:value="item.fid">-->
            <!--</el-option>-->
            <!--</el-select>-->
            <!--</el-form-item>-->
            <!--<el-form-item label="备注：" prop="cfremark"><el-input type="textarea" v-model="area.cfremark" auto-complete="off"></el-input></el-form-item>-->
            <!--</el-form>-->
            <!--<div slot="footer" class="dialog-footer">-->
            <!--<el-button @click="areaFormVisible = false">取 消</el-button>-->
            <!--<el-button type="primary" @click="submitArea">确 定</el-button>-->
            <!--</div>-->
            <!--</el-dialog>-->
            <!--</el-tab-pane>-->

            <el-tab-pane label="专业类别" name="step4">
                <table border strip class="info-table">
                    <tr>
                        <th>序号</th>
                        <th><b>*</b>专业负责人</th>
                        <th><b>*</b>产品及服务</th>
                        <th><b>*</b>服务区域</th>
                        <th>备注</th>
                        <th>操作</th>
                    </tr>
                    <tr v-for="(c, i) in spss" :key="c.id">
                        <td>{{i+1}}</td>
                        <td>{{c.cfcellpeopleid}}</td>
                        <td>{{c.cfservicetypename}}</td>
                        <td>
                            <a style="display:block;" v-for="item in c.names" :key="item">{{item}}</a>
                        </td>
                        <td>{{c.cfremak}}</td>
                        <td>
                            <a @click.prevent="categoryEdit(i)" class="edit-btn">编辑</a>
                            <a @click.prevent="categoryRemove(i)" class="delete-btn">删除</a>
                        </td>
                    </tr>
                    <tr v-if="!spss.length">
                        <td colspan="6">暂无数据</td>
                    </tr>
                </table>
                <div class="splitter"></div>
                <el-button icon="el-icon-plus" @click="categoryAdd">新增</el-button>
                <el-dialog :title="isNaN(editIndex)?'新增专业类别':'编辑专业类别'" :visible.sync="categoryFormVisible">
                    <el-form :model="category" label-width="150px" :rules="rulesCategory" ref="categoryForm"
                             class="supplier-form">
                        <el-form-item label="专业负责人：" prop="cfcellpeopleid">
                            <el-select @change='selectPerson' v-model.trim="category.cfcellpeopleid" placeholder="请选择"
                                       style="float:left">
                                <el-option
                                    v-for="(item,index) in linkpersons"
                                    v-if='item.personType!=1 && item.personType!=4'
                                    :key="index"
                                    :label="item.fpersonname"
                                    :value="{name:item.fpersonname,index:index}">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="产品及服务：" prop="cfservicetypeid">
                            <el-cascader @change="selectServiceType" ref="serviceTyper" v-model="serviceType"
                                         placeholder="输入搜索" expand-trigger="hover"
                                         :options="productTypes" filterable :change-on-select="false"
                                         style="width:100%;"
                            ></el-cascader>
                        </el-form-item>
                        <el-form-item label="服务区域：" prop="provinceArr">
                            <el-select
                                multiple
                                collapse-tags
                                @change="selectProvince"
                                v-model="category.provinceArr"
                                placeholder="请选择省份"
                                style="float:left"
                                filterable class="multipleSel"
                            >
                                <el-option
                                    v-for="item in provinces"
                                    :key="item.fid"
                                    :label="item.fnameL2"
                                    :value="item.fid"
                                ></el-option>
                            </el-select>
                            <el-select
                                multiple
                                collapse-tags
                                v-model="category.cityArr"
                                placeholder="请选择城市"
                                style="float:left;margin-left: 10px;"
                            >
                                <el-option
                                    v-for="item in cityList"
                                    :key="item.fid"
                                    :label="item.fnameL2"
                                    :value="item.fid"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="备注：" prop="cfremak">
                            <el-input type="textarea" v-model="category.cfremak" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="categoryFormVisible = false">取 消</el-button>
                        <el-button type="primary" @click="submitCategory">确 定</el-button>
                    </div>
                </el-dialog>
            </el-tab-pane>


            <el-tab-pane label="项目经理" name="step5">
                <table border strip class="info-table">
                    <tr>
                        <th>序号</th>
                        <th><b>*</b>姓名</th>
                        <th><b>*</b>身份证</th>
                        <th><b>*</b>手机</th>
                        <th>办公电话</th>
                        <th><b>*</b>邮箱</th>
                        <th>专业</th>
                        <th>建造师级别</th>
                        <th>证书编号</th>
                        <th>业绩</th>
                        <th><b>*</b>社保证明</th>
                        <th>操作</th>
                    </tr>
                    <tr v-for="c, i in managers">
                        <td>{{i+1}}</td>
                        <td>{{c.name}}</td>
                        <td><span class="achivement_span" :title="c.idCard">{{c.idCard}}</span></td>
                        <td>{{c.mobile}}</td>
                        <td>{{c.officeTel}}</td>
                        <td><span class="achivement_span" :title="c.email">{{c.email}}</span></td>
                        <td>{{c.major}}</td>
                        <td>{{c.grade}}</td>
                        <td>{{c.certificateNo}}</td>
                        <td><span class="achivement_span" :title="c.achievement">{{c.achievement}}</span></td>
                        <td>
                            <a class="vlink" v-if="c.baseFileList.length"
                                :href="`${downApi}?fileName=${c.baseFileList[0].fileName}&fileOldName=${encodeURIComponent(c.baseFileList[0].fileOldName)}`">{{c.baseFileList[0].fileOldName}}</a>
                            <span v-if="!c.baseFileList.length">无附件</span>
                        </td>
                        <td>
                            <a @click.prevent="managerEdit(i)" class="edit-btn">编辑</a>
                            <a @click.prevent="managerRemove(i)" class="delete-btn">删除</a>
                        </td>
                    </tr>
                    <tr v-if="!managers.length">
                        <td colspan=11>暂无数据</td>
                    </tr>
                </table>
                <div class="splitter"></div>
                <el-button icon="el-icon-plus" @click="managerAdd">新增</el-button>
                <el-dialog :title="isNaN(editIndex)?'新增项目经理':'编辑项目经理'" :visible.sync="managerFormVisible">
                    <el-form :model="manager" label-width="100px" :rules="rulesManager" ref="managerForm"
                             class="supplier-form">
                        <el-form-item label="姓名：" prop="name">
                            <el-input type="text" v-model.trim="manager.name" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="身份证：" prop="idCard">
                            <el-input type="text" v-model="manager.idCard" auto-complete="off" @change="getManagerMobile"></el-input>
                        </el-form-item>
                        <el-form-item label="手机：" prop="mobile">
                            <el-input type="text" v-model="manager.mobile" auto-complete="off"
                                      :maxlength="11"></el-input>
                        </el-form-item>
                        <el-form-item label="办公电话：" prop="officeTel">
                            <el-input type="text" v-model="manager.officeTel" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="邮箱：" prop="email">
                            <el-input type="text" v-model="manager.email" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="专业：" prop="major">
                            <el-input type="text" v-model="manager.major" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="建造师级别：" prop="grade">
                            <el-input type="text" v-model="manager.grade" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="证书编号：" prop="certificateNo">
                            <el-input type="text" v-model="manager.certificateNo" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="业绩：" prop="achievement">
                            <el-input type="text" v-model="manager.achievement" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="社保证明：" prop="baseFileList">
                            <el-upload
                                    :action="uploadApi"
                                    :on-success="setPhotoList"
                                    :limit="1"
                                    :on-exceed="handleExceed"
                                    accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PNG"
                                    :file-list="manager.baseFileList">
                                <el-button size="small" type="primary">点击上传</el-button>
                            </el-upload>(需提供6个月社保缴纳记录证明)
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="managerFormVisible = false">取 消</el-button>
                        <el-button type="primary" @click="submitManager">确 定</el-button>
                    </div>
                </el-dialog>
            </el-tab-pane>

            <el-tab-pane label="业绩信息" name="step6">
                <table border strip class="info-table">
                    <tr>
                        <th>序号</th>
                        <th><b>*</b>工程名称</th>
                        <th><b>*</b>客户名称</th>
                        <th><b>*</b>工程地址</th>
                        <th>联系人</th>
                        <th>联系电话</th>
                        <th><b>*</b>合同总额</th>
                        <th>开始日期</th>
                        <th><b>*</b>结束日期</th>
                        <th>备注</th>
                        <th>附件</th>
                        <th>操作</th>
                    </tr>
                    <tr v-for="a, i in achievements">
                        <td>{{i+1}}</td>
                        <td>{{a.fprojectname}}</td>
                        <td>{{a.fclientname}}</td>
                        <td>{{a.fclientaddress}}</td>
                        <td>{{a.fclientlinkperson}}</td>
                        <td>{{a.fphone}}</td>
                        <td>{{a.fcontractpay}}</td>
                        <td>{{a.fstartdate|date}}</td>
                        <td>{{a.fenddate|date}}</td>
                        <td>{{a.fremark}}</td>
                        <td>
                            <div v-for="file in a.baseFiles" :key="file.id">
                                <a class="vlink" v-if="file.id"
                                   :href="`${baseUrl}rest/file/down?fileId=${file.id}`">
                                    {{file.fileOldName}}
                                </a>
                                <span v-else>{{file.fileOldName}}</span>
                            </div>
                        </td>
                        <td>
                            <a @click.prevent="achieveEdit(i)" class="edit-btn">编辑</a>
                            <a @click.prevent="achieveDelete(i)" class="delete-btn">删除</a>
                        </td>
                    </tr>
                    <tr v-if="!achievements.length">
                        <td colspan=12>暂无数据</td>
                    </tr>
                </table>
                <div class="splitter"></div>
                <el-button icon="el-icon-plus" @click="achieveAdd">新增</el-button>

                <el-dialog :title="isNaN(editIndex)?'新增业绩':'编辑业绩'" :visible.sync="achieveFormVisible">
                    <el-form :model="achievement" label-width="100px" :rules="rulesAchievement" ref="achieveForm" class="supplier-form">
                        <el-form-item label="工程名称：" prop="fprojectname">
                            <el-input type="text" v-model.trim="achievement.fprojectname" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="客户名称：" prop="fclientname">
                            <el-input type="text" v-model.trim="achievement.fclientname" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="工程地址：" prop="fclientaddress">
                            <el-input type="text" v-model="achievement.fclientaddress" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="联系人：">
                            <el-input v-model="achievement.fclientlinkperson" type="text" placeholder=""></el-input>
                        </el-form-item><!-- prop="fclientlinkperson" -->
                        <el-form-item label="联系电话：">
                            <el-input type="text" v-model="achievement.fphone" auto-complete="off"
                                      :maxlength="11"></el-input>
                        </el-form-item><!-- prop="fphone" -->
                        <el-form-item label="合同总额：" prop="fcontractpay">
                            <el-input type="text" placeholder="请输入数字" v-model="achievement.fcontractpay"
                                      auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="开始日期：">
                            <el-date-picker type="date" v-model="achievement.fstartdate" auto-complete="off"
                                            value-format="yyyy-MM-dd hh:mm:ss"></el-date-picker>
                        </el-form-item><!-- prop="fstartdate" -->
                        <el-form-item label="结束日期：" prop="fenddate">
                            <el-date-picker type="date" v-model="achievement.fenddate" auto-complete="off"
                                            value-format="yyyy-MM-dd hh:mm:ss"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="备注：" prop="fremark">
                            <el-input type="text" v-model="achievement.fremark" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="附件：" prop="">
                            <el-upload class="upload"
                                       ref="achUpload"
                                       :action="uploadApi"
                                       :on-success="handleChangeAchieve"
                                       :on-error="uploadError"
                                       :on-preview="handlePreview"
                                       :on-remove="handleRemoveAchieve"
                                       :before-remove="beforeRemove"
                                       :before-upload="beforeUpload"
                                       multiple
                                       :limit="3"
                                       :on-exceed="handleExceed"
                                       :file-list="achievement.baseFiles">
                                <el-button size="small" type="primary">点击上传</el-button>
                                <div slot="tip" class="el-upload__tip">上传附件大小请不要超过100M。<br>
                                    <span class="redTip">注意：附件上传出现绿色打勾标志，才表示上传成功。</span></div>
                            </el-upload>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="achieveFormVisible = false">取 消</el-button>
                        <el-button type="primary" @click="submitAchieve">确 定</el-button>
                    </div>
                </el-dialog>
            </el-tab-pane>
            <el-tab-pane label="资质文件" name="step7">
                <table border strip class="info-table">
                    <tr>
                        <th>序号</th>
                        <th><b>*</b>资质名称及等级</th>
                        <th><b>*</b>开始时间</th>
                        <th><b>*</b>到期时间</th>
                        <th>颁发单位</th>
                        <th>备注</th>
                        <th><b>*</b>附件</th>
                        <th>操作</th>
                    </tr>
                    <tr v-for="f, i in aptitudefiles">
                        <td>{{i+1}}</td>
                        <td>{{f.faptname}}</td>
                        <td>{{f.fstartdate|date}}</td>
                        <td>{{f.fenddate|date}}</td>
                        <td>{{f.fawardunit}}</td>
                        <td>{{f.fremark}}</td>
                        <td>
                            <div v-for="file in f.baseFiles" :key="file.id">
                                <a class="vlink" v-if="file.id"
                                   :href="`${baseUrl}rest/file/down?fileId=${file.id}`">
                                    {{file.fileOldName}}
                                </a>
                                <span v-else>{{file.fileOldName}}</span>
                            </div>
                        </td>
                        <td>
                            <a @click.prevent="aptEdit(i)" class="edit-btn">编辑</a>
                            <a @click.prevent="aptRemove(i)" class="delete-btn">删除</a>
                        </td>
                    </tr>
                    <tr v-if="!aptitudefiles.length">
                        <td colspan=9>暂无数据</td>
                    </tr>
                </table>
                <div class="splitter"></div>
                <el-button icon="el-icon-plus" @click="aptAdd">新增</el-button>
                <el-dialog :title="isNaN(editIndex)?'新增资质文件':'编辑资质文件'" :visible.sync="aptitudeFormVisible">
                    <el-form :model="aptitude" label-width="140px" :rules="rulesAptitude" ref="aptitudeForm" class="supplier-form">
                        <el-form-item label="资质名称及等级：" prop="faptname">
                            <el-cascader @change="selectApt" ref="aptTyper" v-model="aptType"
                                         placeholder="输入搜索" expand-trigger="hover"
                                         :options="apts" filterable :change-on-select="false"
                                         style="width:100%;"
                            ></el-cascader>
                        </el-form-item>
                        <el-form-item label="开始时间：" prop="fstartdate">
                            <el-date-picker v-model="aptitude.fstartdate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd hh:mm:ss"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="到期时间：" prop="fenddate">
                            <el-date-picker v-model="aptitude.fenddate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd hh:mm:ss"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="颁发单位：" prop="fawardunit">
                            <el-input type="text" v-model.trim="aptitude.fawardunit" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="备注：" prop="fremark">
                            <el-input type="text" v-model="aptitude.fremark" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="附件：" prop="baseFiles">
                            <el-upload class="upload"
                                       ref="aptUpload"
                                       :action="uploadApi"
                                       :on-success="handleChange"
                                       :on-error="uploadError"
                                       :on-preview="handlePreview"
                                       :on-remove="handleRemove"
                                       :before-remove="beforeRemove"
                                       :before-upload="beforeUpload"
                                       :limit="3"
                                       multiple
                                       :on-exceed="handleExceed"
                                       :file-list="aptitude.baseFiles">
                                <el-button size="small" type="primary">点击上传</el-button>
                                <div slot="tip" class="el-upload__tip">上传附件大小请不要超过100M。<br>
                                    <span class="redTip">注意：附件上传出现绿色打勾标志，才表示上传成功。</span></div>
                            </el-upload>
                        </el-form-item>
                    </el-form>


                    <div slot="footer" class="dialog-footer">
                        <el-button @click="aptitudeFormVisible = false">取 消</el-button>
                        <el-button type="primary" @click="submitAptitude">确 定</el-button>
                    </div>
                </el-dialog>
            </el-tab-pane>
            <el-tab-pane label="三年销售额" name="step8">
                <table border strip class="info-table">
                    <tr>
                        <th>序号</th>
                        <th><b>*</b>年份</th>
                        <th><b>*</b>销售额（万元）</th>
                        <th>操作</th>
                    </tr>
                    <tr v-for="s, i in yearsales">
                        <td>{{i+1}}</td>
                        <td>{{s.fyear}}</td>
                        <td>{{s.fsalecount}}</td>
                        <td><a @click.prevent="editSales(i)" class="edit-btn">编辑</a></td>
                    </tr>
                    <tr v-if="!yearsales.length">
                        <td colspan=5>暂无数据</td>
                    </tr>
                </table>
                <div class="splitter"></div>
                <el-button icon="el-icon-plus" @click="addYearSales" v-if="yearsales.length<3">新增</el-button>
                <el-dialog :title="isNaN(editIndex)?'新增近三年销售额':'编辑近三年销售额'" width="640px"
                           :visible.sync="salesFormVisible">
                    <el-form :model="yearsale" label-width="100px" :rules="rulesSales" ref="salesForm"
                             class="supplier-form">
                        <el-form-item label="年份：" prop="fyear">
                            <el-input type="text" v-model.number="yearsale.fyear" :maxlength="4" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="销售额：" prop="fsalecount">
                            <el-input type="number" v-model.number="yearsale.fsalecount" auto-complete="off" :maxlength="10">
                                <template slot="append">万元</template>
                            </el-input>
                        </el-form-item><!-- prop="fsalecount" -->
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="salesFormVisible = false">取 消</el-button>
                        <el-button type="primary" @click="submitSales">确 定</el-button>
                    </div>
                </el-dialog>
            </el-tab-pane>

            <el-tab-pane label="银行信息" name="step9">
                <table border strip class="info-table">
                    <tr>
                        <th>序号</th>
                        <th><b>*</b>银行所在市</th>
                        <th><b>*</b>银行开户名</th>
                        <th><b>*</b>银行联行号</th>
                        <th><b>*</b>开户行全称</th>
                        <th><b>*</b>银行账号</th>
                        <th v-if="accountType == '1'">账户类型</th>
                        <th>操作</th>
                    </tr>
                    <tr v-for="(a, i) in bankInfo" :key="i">
                        <td>{{i+1}}</td>
                        <td>{{a.address}}</td>
                        <td>{{a.accountName}}</td>
                        <td>{{a.relationNo}}</td>
                        <td>{{a.name}}</td>
                        <td>{{a.bankNo}}</td>
                        <td v-if="accountType == '1'">{{a.bankType}}</td>
                        <td><a @click.prevent="bankInfoEdit(i)" class="edit-btn">编辑</a><a @click.prevent="bankInfoRemove(i)" class="delete-btn">删除</a></td>
                    </tr>
                    <tr v-if="!bankInfo.length"><td colspan=6>暂无数据</td></tr>
                </table>
                <div class="splitter"></div>
                <el-button icon="el-icon-plus" @click="bankInfoAdd">新增</el-button>
                <el-dialog :title="isNaN(editIndex)?'新增银行信息':'编辑银行信息'" :visible.sync="bankInfoFormVisible">
                <el-form :model="bankTemp" label-width="120px" :rules="bankRules" ref="bankForm" class="supplier-form">
                    <el-form-item label="银行所在市：" prop="address">
                        <el-input type="text" v-model.trim="bankTemp.address" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="银行开户名：" prop="accountName">
                        <el-input type="text" v-model.trim="bankTemp.accountName" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="银行联行号：" prop="relationNo">
                        <el-input type="text" v-model.trim="bankTemp.relationNo" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="开户行全称：" prop="name">
                        <el-input type="text" v-model.trim="bankTemp.name" auto-complete="off"></el-input>
                    </el-form-item>
                    <br/>
                    <el-form-item label="银行账号：" prop="bankNo">
                        <el-input type="text" v-model.trim="bankTemp.bankNo" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="账号类型：" prop="bankType" v-if="accountType == '1'">
                        <el-select v-model="bankTemp.bankType" placeholder="选择银行类型">
                            <el-option label="专户" value="专户"></el-option>
                            <el-option label="一般户" value="一般户"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="bankInfoFormVisible = false">取 消</el-button>
                        <el-button type="primary" @click="closeBankInfo">确 定</el-button>
                    </div>
                </el-dialog>
            </el-tab-pane>
        </el-tabs>
        <div class="text-center">
            <el-button type="" @click="prev">上一步</el-button>
            <el-button type="primary" @click="next" :disabled="isSubmit">下一步</el-button>
        </div>
    </div>
</template>

<script type="text/babel">
    import util from '@/util'
    import {mapGetters, mapActions, mapMutations} from 'vuex'
    import {
        SELECT_PROVINCE, ADD_SPSS, UPDATE_TAXPAYER_TYPE, UPDATE_COMPANY_TYPE, ADD_MANAGER, EDIT_MANAGER, REMOVE_MANAGER
    } from '@/store/mutation-types'
    import apis from '@/store/apis'
    import {
        companyRules,
        contactRules,
        areaRules,
        spssRules,
        managerRules,
        salesRules,
        achievementRules,
        aptitudeRules,
        gysfjRules,
        rulesBank
    } from '@/util/rules'
    import filter from '@/filter'

    export default {
        name: 'register-company',
        filters: filter,
        data() {
            return {
                utilBaseUrl: util.baseUrl.replace(':9007', ':11020'),
                baseUrl: util.baseUrl,
                activeName: 'step1',
                managerlimit: false,
                rules: {
                    fbusinessnum: [
                        { required: true, message: '请输入公司统一社会信用代码', trigger: 'change' },
                        {pattern:  /^(?!.*[\s])/g,message:'请勿输入空格、回车等非法字符',trigger:'blur'},
                        {validator: this.checkBusinessNum, trigger: 'blur' }
                    ],
                    ...companyRules
                },
                contact: {
                    fpersonname: '',
                    idCard: '',
                    personType: '',
                    fposition: '',
                    fphone: '',
                    fworkphone: '',
                    femail: '',
                    remark: ''
                },
                rulesContact: contactRules,
                area: {
                    cfprovinceid: '',
                    cfcityid: '',
                    cfremark: '', // 备注
                    province: '',
                    city: ''
                },
                rulesManager: managerRules,
                manager: {
                    name: '',
                    idCard: '',
                    mobile: '',
                    officeTel: '',
                    email: '',
                    major: '',
                    grade: '',
                    certificateNo: '',
                    achievement: '',
                    baseFileList: []
                },
                rulesArea: areaRules,
                category: {
                    linkOrder: '',
                    farParent: '',
                    cfcellpeopleid: '', //
                    cfservicetypename: '',
                    cfservicetypeid: '', // 产品及服务id
                    provinceArr: [],
                    cityArr: [],
                    servicename: "",
                    cfremak: ''
                },
                serviceType: [],
                cityList: [],
                province_city: {},
                aptType: [],
                rulesCategory: spssRules,
                categoryFormVisible: false,
                contactFormVisible: false,
                areaFormVisible: false,
                managerFormVisible: false,
                salesFormVisible: false,
                achieveFormVisible: false,
                aptitudeFormVisible: false,
                gysfjVisible: false,
                rulesGysfj: gysfjRules,
                companyType: {
                    fsuppliertypeid: '',
                    fsuppliertypename: ''
                },
                rulesSales: salesRules,
                rulesAchievement: achievementRules,
                rulesAptitude: aptitudeRules,
                yearsale: {// （近三）年销售
                    fyear: '',
                    fsalecount: ''
                },
                achievement: {// 业绩
                    fprojectname: '', // 工程名称
                    fclientname: '', // 客户名称
                    fclientaddress: '', // 工程地址
                    fclientlinkperson: '', // 客户联系人
                    fphone: '', // 电话
                    fcontractpay: '', // 合同金额
                    fstartdate: '', // 开始日期
                    fenddate: '', // 结束日期
                    fremark: '', // 备注
                    baseFiles: []
                },
                aptitude: {
                    faptnumber: '',
                    faptname: '',
                    faptlevel: '',
                    fstartdate: '',
                    fenddate: '',
                    fawardunit: '',
                    fremark: '',
                    farParent: '',
                    qualificationId: '',
                    baseFiles: []
                }, // 资质
                gysfj: {
                    baseFiles: []
                },
                fileList: [],
                fsuppliertypeid: '',
                editIndex: void (0),
                typeArray: [],
                fileList: [],
                uploadApi: `${util.baseUrl}rest/file/upload`,
                fileSort: 1,
                bankInfoFormVisible: false,
                bankTemp: {
                    bankType: null
                },
                bankRules: rulesBank,
                downApi: `${util.baseUrl}rest/file/down`,
                accountType: null,
                isSubmit: false
            }
        },
        computed: {
            ...mapGetters(['account', 'linkpersons', 'serviceas', 'spss', 'provinces', 'apts', 'cities',
            'companyTypes', 'productTypes', 'taxpayerTypes', 'contactTypes', 'managers', 'other',
            'enterpriseTypes', 'yearsales', 'achievements', 'aptitudefiles', 'linkstosps', 'productTypes',
            'gysfjs', 'bankInfo'])
        },
        watch: {
            'account.fprovinceid': function (fid) {
                this.setPid(fid)
                this.getCities()
            },
            'area.cfprovinceid': function (fid) {
                if (fid) {
                    this.setPid(fid)
                    this.getCities()
                    this.area.province = this.provinces.find(p => {
                        return p.fid == fid
                    }).fnameL2
                }
            },
            'area.cfcityid': function (cid) {
                if (cid) {
                    this.area.city = this.cities.find(c => {
                        return c.fid == cid
                    }).fnameL2
                }
            },
            company: {
                handler: function (val, oldValue) {
//                    console.log(val)
                },
                deep: true
            },
            spss: {
                handler: function (val, oldValue) {
                    this.selAccountType(val)
                },
                deep: true
            }
        },
        methods: {
            ...mapActions(['submitAccount', 'goStep', 'getProvinces', 'getCities', 'getApt', 'getProductTypes', 'getCompanyTypes',
                'addOrEditContact', 'removeContact', 'addOrEditArea', 'removeArea', 'addOrEditCategory',
                'removeCategory', 'addOrEditManager', 'removeManager', 'addOrEditSales', 'addOrEditAchieve', 'removeAchieve',
                'addOrEditApt', 'removeApt', 'submitRegister', 'addOrEditGysf', 'addOrEditBankInfo', 'removeBankInfo'
            ]),
            ...mapMutations({
                setPid: SELECT_PROVINCE,
                updateTaxpayerType: UPDATE_TAXPAYER_TYPE,
                updateCompanyType: UPDATE_COMPANY_TYPE
            }),
            selAccountType (val, oldValue) {
                this.$http.post('rest/api/completeFourInfo/selectAccountType', Object.assign([], val)).then((res)=>{
                    if (res.data.result) {
                        this.accountType = res.data.value
                    }
		        })
            },
            handleClick() {

                let step = this.activeName.substr(-1) - 0
                if(step>=5){
                    if(this.spss.length==0){
                        alert('请先添加专业类别')
                        this.activeName = 'step4'
                        return;
                    }
                    this.checkProductType()
                }
            },
            prev() {
                let step = this.activeName.substr(-1)
                if (step > 1) {
                    this.activeName = `step${step - 1}`
                } else {
                    this.$router.push('/register')
                }
            },
            next() {
                this.isSubmit = true

                let step = this.activeName.substr(-1) - 0
                if (step == 1) {
                    this.submitAccount()
                }
                if (step < 9) {
                    this.activeName = `step${step + 1}`
                    this.isSubmit = false
                } else {
                    this.$refs.companyForm.validate((valid) => {
                        if (valid) {
                            if (this.linkpersons.length < 2) {
                                alert('联系人中至少要添加一个上级负责人，请在联系人列表，点击新增按钮添加！！')
                                this.activeName = 'step3'
                                this.isSubmit = false
                                return
                            }

                            if (!this.spss.length) {
                                alert('至少要添加一个专业类别！')
                                this.activeName = 'step4'
                                this.isSubmit = false
                                return
                            }

                            if (!this.aptitudefiles.length) {
                                alert('至少要添加一条资质信息！')
                                this.activeName = 'step7'
                                this.isSubmit = false
                                return
                            }

                            if (!this.bankInfo.length) {
                                alert('至少要添加一个银行账号！')
                                this.activeName = 'step9'
                                this.isSubmit = false
                                return
                            }
                            this.aptitude.baseFiles = __getBaseFiles__(null, this.$refs.aptUpload.uploadFiles)
                            this.submitForm()
                        } else {
                            this.activeName = 'step1'
                            this.isSubmit = false
                        }
                    })
                }
            },
            submitContact() {
                this.$refs.contactForm.validate((valid) => {
                    if (valid) {
                        this.addOrEditContact({contact: this.contact, editIndex: this.editIndex})
                        this.contactFormVisible = false
                    } else {
                        console.log('error submit!!')
                    }
                })
            },
            contactAdd() {
                this.editIndex = void (0)
                this.contact = {
                    fpersonname: '',
                    idCard: '',
                    personType: '',
                    fposition: '',
                    fphone: '',
                    fworkphone: '',
                    femail: '',
                    remark: ''
                }
                this.contactFormVisible = true
                this.$nextTick(() => {
                    this.$refs.contactForm.resetFields()
                    if (this.linkpersons.length == 1) {
                        this.contact.personType = '1'
                    }
                })
            },
            contactEdit(i) {
                this.editIndex = i
                this.contactFormVisible = true
                this.$nextTick(() => {
                    this.contact = Object.assign({}, this.linkpersons[i])
                })
            },
            contactRemove(i) {
                this.removeContact(i)
            },
            closeBankInfo() {
                this.$refs.bankForm.validate((valid) => {
                    if (valid) {
                        this.addOrEditBankInfo({bankInfo: this.bankTemp, editIndex: this.editIndex})
                        this.bankInfoFormVisible = false
                    } else {
                        console.log('error submit!!')
                    }
                })
            },
            bankInfoAdd() {
                this.editIndex = void (0)
                this.bankTemp = {
                    address: '',
                    accountName: '',
                    relationNo: '',
                    name: '',
                    bankNo: '',
                    bankType: null
                }
                this.bankInfoFormVisible = true
                this.$nextTick(() => {
                    this.$refs.bankForm.resetFields()
                })
            },
            bankInfoEdit(i) {
                this.editIndex = i
                this.bankInfoFormVisible = true
                this.$nextTick(() => {
                    this.bankTemp = Object.assign({}, this.bankInfo[i])
                })
            },
            bankInfoRemove(i) {
                this.removeBankInfo(i)
            },
            managerAdd() {
                this.editIndex = void (0)
                this.managerFormVisible = true
                this.manager = {
                    name: '',
                    idCard: '',
                    mobile: '',
                    officeTel: '',
                    email: '',
                    major: '',
                    grade: '',
                    certificateNo: '',
                    achievement: '',
                    baseFileList: []
                }

                this.$nextTick(() => {
                    this.$refs.managerForm.resetFields()
                })
            },
            managerEdit(i) {
                this.editIndex = i
                this.manager = Object.assign({}, this.managers[i])

                if (this.manager.baseFileList.length > 0) {
                    this.manager.baseFileList[0].name = this.manager.baseFileList[0].fileOldName
                }

                this.managerFormVisible = true
            },
            managerRemove(i) {
                this.removeManager(i)
            },
            submitManager() {
                this.$refs.managerForm.validate((valid) => {
                    if (valid) {
                        let payload = {manager: this.manager, editIndex: this.editIndex}
                        this.addOrEditManager(payload)

                        this.managerFormVisible = false
                    } else {
                        console.log('error submit!!')
                    }
                })
            },
            achieveAdd() {
                this.editIndex = void (0)
                this.achieveFormVisible = true
                this.achievement = {
                    fprojectname: '',
                    fclientname: '',
                    fclientaddress: '',
                    fclientlinkperson: '',
                    fphone: '',
                    fcontractpay: '',
                    fstartdate: '',
                    fenddate: '',
                    fremark: '',
                    baseFiles: []
                }
                this.$nextTick(() => {
                    this.$refs.achieveForm.resetFields()
                })
            },
            achieveEdit(i) {
                this.editIndex = i
                this.achieveFormVisible = true
                this.achievement = Object.assign({}, this.other.achievements[i])
            },
            achieveDelete(i) {
                this.removeAchieve(i)
            },
            submitAchieve() {
                var re = /^[0-9]+.?[0-9]*$/
                if (!re.test(this.achievement.fcontractpay)) {
                    this.$message({message: '合同金额请输入数字', type: 'error'})
                    return
                }
                this.$refs.achieveForm.validate((valid) => {
                    if (valid) {
                        let payload = {achievement: this.achievement, editIndex: this.editIndex}
                        this.addOrEditAchieve(payload)

                        this.achieveFormVisible = false
                    }
                })
            },
            aptAdd() {
                this.editIndex = void (0)
                this.aptitudeFormVisible = true
                this.aptitude = {
                    faptnumber: '',
                    faptname: '',
                    faptlevel: '',
                    fstartdate: '',
                    fenddate: '',
                    fawardunit: '',
                    fremark: '',
                    farParent: '',
                    qualificationId: '',
                    baseFiles: []
                }
                this.aptType = []
                this.$nextTick(() => {
                    this.$refs.aptitudeForm.resetFields()
                })
            },
            aptEdit(i) {
                this.editIndex = i
                this.aptitude = Object.assign({}, this.other.aptitudefiles[i])
                this.$nextTick(() => {
                    this.aptType = this.aptitude.farParent.split(',')
                })
                this.aptitudeFormVisible = true
            },
            aptRemove(i) {
                this.removeApt(i)
            },
            submitAptitude() {
                this.$refs.aptitudeForm.validate((valid) => {
                    if (valid) {
                        if (new Date(this.aptitude.fstartdate).getTime() > new Date().getTime()) {
                            this.$message({message: '开始时间不能大于当前时间', type: 'error'})
                            return
                        }
                        if (new Date(this.aptitude.fstartdate).getTime() > new Date(this.aptitude.fenddate).getTime()) {
                            this.$message({message: '开始时间不能大于到期时间', type: 'error'})
                            return
                        }
                        let payload = {aptitude: this.aptitude, editIndex: this.editIndex}
                        this.addOrEditApt(payload)
                        this.aptitudeFormVisible = false
                    }
                })
            },
            addYearSales() {
                this.editIndex = void (0)
                this.salesFormVisible = true

                this.yearsale = {
                    fyear: '',
                    fsalecount: ''
                }

                this.$nextTick(() => {
                    this.$refs.salesForm.resetFields()
                    let thisYear = (new Date()).getFullYear()
                    switch (this.yearsales.length) {
                        case 2:
                            this.yearsale.fyear = thisYear - 2;
                            break
                        case 1:
                            this.yearsale.fyear = thisYear - 1;
                            break
                        default:
                            this.yearsale.fyear = thisYear
                    }
                })
            },
            editSales(i) {
                this.editIndex = i
                this.salesFormVisible = true
                this.yearsale = Object.assign({}, this.other.yearsales[i])
            },
            submitSales() {
                var re = /^[0-9]+.?[0-9]*$/
                if (!re.test(this.yearsale.fsalecount)) {
                    this.$message({message: '销售额必须为数字', type: 'error'})
                    return
                }
                this.$refs.salesForm.validate((valid) => {
                    if (valid) {
                        let payload = {yearsale: this.yearsale, editIndex: this.editIndex}
                        this.addOrEditSales(payload)
                        this.salesFormVisible = false
                    }
                })
            },

            categoryAdd() {
                this.editIndex = void (0)
                this.category = {
                    linkOrder: '',
                    farParent: '',
                    cfcellpeopleid: '', //
                    cfservicetypename: '',
                    cfservicetypeid: '', // 产品及服务id
                    provinceArr: [],
                    cityArr: [],
                    servicename: "",
                    cfremak: ''
                }
                this.serviceType = []
                this.cityList = [];
                this.categoryFormVisible = true
                this.$nextTick(() => {
                    this.$refs.categoryForm.resetFields()
                })
            },
            categoryEdit(i) {
                this.editIndex = i
                this.category = Object.assign({}, this.spss[i])
                this.selectProvince(this.category.provinceArr)
                this.categoryFormVisible = true
                this.$nextTick(() => {
                    this.serviceType = this.category.farParent.split(',');
                    this.category.cityArr = this.spss[i].cityArr;
                })
            },
            categoryRemove(i) {
                this.removeCategory(i)
            },
            //省份选择回调
            selectProvince(val) {
                //重置城市选项
                this.cityList = [];
                val.forEach(item => {
                    Promise.all([this.setPid(item), this.getCities()])
                        .then(r => {
                            if (!this.province_city[item]) this.province_city[item] = this.cities.map(val => {
                                return val.fid;
                            });  //存储城市省份关联关系
                            this.cityList = this.cityList.concat(this.cities);
                            this.$root.loading = false;
                        })
                        .catch(err => (this.$root.loading = false));
                });
                this.$nextTick(() => {
                    //重置已选城市
                    let cityArr = [];
                    this.category.cityArr.forEach(row => {
                        let cityObj = this.cityList.find(value => {
                            return value.fid == row;
                        });
                        if (cityObj) {
                            cityArr.push(row);
                        }
                    });
                    this.category.cityArr = cityArr;
                });
            },
            resetServiceList() {
                let list = [], names = [];
                //遍历所选城市
                this.category.cityArr.forEach(city => {
                    for (let province in this.province_city) {
                        if (this.province_city[province].indexOf(city) != -1) {
                            list.push({
                                cfprovinceid: province,
                                cfcityid: city
                            })
                        }
                    }
                })
                let pArr = list.map(pId => {
                    return pId.cfprovinceid;
                })
                this.category.provinceArr.forEach(province => {
                    if (pArr.indexOf(province) == -1) {
                        list.push({
                            cfprovinceid: province,
                            cfcityid: ''
                        })
                    }
                })
                list.forEach(obj => {
                    let pObj = this.provinces.find(val => {
                        return obj.cfprovinceid == val.fid;
                    })
                    let cObj = this.cityList.find(val => {
                        return obj.cfcityid == val.fid;
                    })
                    if (cObj) {
                        names.push(pObj.fnameL2 + '-' + cObj.fnameL2);
                    } else {
                        names.push(pObj.fnameL2);
                    }

                })
                this.category['serviceaList'] = list;
                this.category['names'] = names;
            },
            submitCategory() {
                console.log(this.category,'category');
                this.$refs.categoryForm.validate((valid) => {
                    if (valid) {
                        this.resetServiceList();
                        this.addOrEditCategory({category: this.category, editIndex: this.editIndex})
                        this.categoryFormVisible = false
                    } else {
                        console.log('error submit!!')
                    }
                })
            },

            selectCompanyType(types) {
                this.$nextTick(()=>{
                    let typer = this.$refs.companyTyper
                    this.companyType.fsuppliertypename = typer.getCheckedNodes()[0].pathLabels.join(' / ')
                    this.companyType.fsuppliertypeid = typer.getCheckedNodes()[0].value
                    this.updateCompanyType(this.companyType.fsuppliertypeid)// ===this.account.fsuppliertypeid = this.companyType.fsuppliertypeid
                })
            },
            selectPerson(data) {
                this.category.linkOrder = data.index
                this.category.cfcellpeopleid = data.name
            },
            selectServiceType(types) {
                this.$nextTick(()=>{
                    let typer = this.$refs.serviceTyper;
                    console.log(typer.getCheckedNodes(),'wudi')
                    this.category.cfservicetypename = typer.getCheckedNodes()[0].pathLabels.join(' / ')
                    this.category.cfservicetypeid = typer.getCheckedNodes()[0].value;
                    this.category.farParent = typer.getCheckedNodes()[0].path.join(',')
                })
            },
            selectApt(types) {
                this.$nextTick(()=>{
                    let typer = this.$refs.aptTyper
                    this.aptitude.faptname = typer.getCheckedNodes()[0].pathLabels.join(' / ')
                    this.aptitude.faptnumber = typer.getCheckedNodes()[0].pathLabels.join(' / ')
                    this.aptitude.faptlevel = typer.getCheckedNodes()[0].pathLabels.join(' / ')
                    this.aptitude.qualificationId = typer.getCheckedNodes()[0].value
                    this.aptitude.farParent = typer.getCheckedNodes()[0].pathLabels.join(',')
                })
            },
            addGysfj (sort) {
                // 设置排序-确定是什么承诺函
                this.fileSort = sort
                this.gysfjVisible = true

                if (this.$refs.fileup) {
                    this.$refs.fileup.clearFiles()
                }

                this.$nextTick(() => {
                    this.$refs.gysfjForm.resetFields()
                })

                this.gysfj.baseFiles = []
            },
            submitGysfj() {
                this.$refs.gysfjForm.validate((valid) => {
                    if (valid) {
                        let tempFiles = this.gysfj.baseFiles
                        if (tempFiles.length > 0) {
                            if (!this.gysfjs) {
                                this.gysfjs = []
                            }
                            // 是否替换标记
                            let instateFlag = false
                            // 需要遍历替换或者增加里面的附件
                            this.gysfjs.forEach((element, i) => {
                                if (this.fileSort == element.sort) {
                                    // 如果是同一个种类的
                                    this.gysfjs[i] = tempFiles[0]
                                    instateFlag = true
                                }
                            })

                            if (!instateFlag) {
                                this.gysfjs.push(tempFiles[0])
                            }

                            let payload = {gysfj:this.gysfjs, editIndex:this.editIndex}
                            this.addOrEditGysf(payload)
                        }
                        this.gysfjVisible = false
                    }
                })
            },
            submitForm() {
                // this.$root.loading = true
                const loading = this.$loading({background: 'rgba(255,255,255,0.5)'})
                this.submitRegister({
                    'cb': (loginName) => {
                        window.sessionStorage.setItem('loginName', loginName)
                        // this.$root.loading = false
                        loading.close()
                        this.$message({message: '提交成功', type: 'success'})
                        this.$router.push({
                            path: '/login',
                            query: {redirect: '/supplier'}
                        })
                    },
                    'ecb': (err) => {
                        // this.$root.loading = false
                        loading.close()
                        this.$alert(err)
                        this.isSubmit = false
                    }
                })
            },
            checkCompanyName(rule, value, callback) { // 检查供应商名称
                apis.checkCompanyName(value).then((res) => {
                    if (res.data.result) {
                        callback()
                    } else {
                        callback(new Error(res.data.message))
                    }
                }, e => alert(e))
            },
            validatePhone(rule, value, callback) {
                if (/1[3-9]\d{9}/.test(value)) {
                    apis.checkPhone(value).then((res) => {
                        if (res.data.result) {
                            callback()
                        } else {
                            callback(new Error(res.data.message))
                        }
                    })
                } else {
                    callback(new Error('手机号码不正确'))
                }
            },
            handleChangeAchieve(response, file, fileList) {
                this.achievement.baseFiles = __getBaseFiles__(null, this.$refs.achUpload.uploadFiles)
            },
            handleRemoveAchieve(file, fileList) {
                this.achievement.baseFiles = this.achievement.baseFiles.filter(function (f) {
                    return f.uid !== file.uid
                })
            },
            handleChange(response, file, fileList) {
                this.aptitude.baseFiles = __getBaseFiles__(file, fileList)
            },
            handleRemove(file, fileList) {
                this.aptitude.baseFiles = this.aptitude.baseFiles.filter(function (f) {
                    return f.uid !== file.uid
                })
            },
            handleChangeGysfj(response, file, fileList) {
                response.basefiles[0].sort = this.fileSort
                this.gysfj.baseFiles.push(this.getGysfj(response))
            },
            handleRemoveGysfj(file, fileList) {
                this.gysfj.baseFiles = this.gysfj.baseFiles.filter(function (f) {
                    return f.uid !== file.uid
                })
            },
            handlePreview(file) {
            },
            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
            },
            handleExceed1(files, fileList) {
                this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件,请先删除之前的文件`)
            },
            beforeRemove(file) {
                return this.$confirm(`确定移除 ${file.name}？`)
            },
            beforeUpload(file) {
                if (!util.allowUpload(file.name)) {
                    this.$alert(`支持的文件类型：${util.acceptFileTypes.join(' | ')}`, '文件类型不支持，已取消上传！', {type: 'error'})
                    return false
                }
                return true
            },

            uploadError() {
                this.$message({message: '上传出错，请稍后再试。', type: 'error'})
            },

            getGysfj(file){
                // let f = file.response.basefiles[0]
                let f = file.basefiles[0]
                file.fileOldName = f.fileoldname
                file.fileName = f.filename
                file.filePath = f.filepath
                file.fileSize = f.filesize
                file.fileType = f.filetype
                file.sort = f.sort
                file.name = f.fileoldname
                return file
            },
            setPhotoList : function(response, file, fileList) {
                this.manager.baseFileList = []
                this.manager.baseFileList = this.setFileLists(file, fileList)
            },
            handleExceed(files, fileList) {
                this.$message.warning('当前限制选择 1 个文件');
            },
            setFileLists (file, fileList) {
                let fs = [];
                fileList.forEach(function (item) {
                    console.log(item)
                    if (item.response) {
                        let f = item.response.basefiles[0];
                        item.bizTableName = f.biztablename;
                        item.bizTablePkName = f.biztablepkname;
                        item.bizTablePkValue = f.biztablepkvalue;
                        item.fid = f.fid;
                        item.fileCatagoryId = f.filecatagoryid;
                        item.fileDesc = f.filedesc;
                        item.fileOldName = f.fileoldname;
                        item.name = f.fileoldname;
                        item.fileName = f.filename;
                        item.filePath = f.filepath;
                        item.fileSize = f.filesize;
                        item.fileType = f.filetype;
                        item.sort = f.sort;
                    }
                    fs.push(item);
                });
                return fs
            },
            getManagerMobile () {
                if (this.manager.idCard.length == 18) {
                    let tempLinkArray = this.linkpersons.filter(item => item.idCard == this.manager.idCard)

                    this.manager.mobile = (!!tempLinkArray && tempLinkArray.length > 0) ? tempLinkArray[0].fphone : ''
                }
            },
            checkBusinessNum(rule, value, callback) {
                if (!value) {
                    callback(new Error('统一社会信用代码必须填写'))
                } else {
                    if(value.length==15||value.length==18){
                        this.$http.get(`/rest/api/dspUserApi/checkFBusinessNum?fbusinessnum=${value}`).then((res) => {
                            if (res.data.result) {
                                callback()
                            } else {
                                callback(new Error(res.data.message))
                            }
                        })
                    }else{
                        callback(new Error("长度必须为15位或18位"))

                    }

                }
            },
            checkProductType(){
                var productTypeIds = "";
                for (var i = 0; i < this.spss.length; i++) {
                    productTypeIds += this.spss[i].cfservicetypeid+ ",";
                }
                productTypeIds = productTypeIds.substr(0, productTypeIds.length - 1);
                let param = {productTypeIds:productTypeIds}
                apis.getIsManagerLimit(param,this.managerlimit);
            },
        },
        mounted() {
            this.goStep(1)
            window.c = this.linkpersons
        },
        created() {
            this.getProvinces()
            this.getApt()
            this.getProductTypes()
            this.getCompanyTypes()
        }
    }

    function __getBaseFiles__(file, fileList) {
        let fs = []
        fileList.forEach(function (item) {
            console.log(item)
            if (item.response) {
                let f = item.response.basefiles[0]
                item.fileOldName = f.fileoldname
                item.name = f.fileoldname
                item.fileName = f.filename
                item.filePath = f.filepath
                item.fileSize = f.filesize
                item.fileType = f.filetype
                item.sort = f.sort
            }
            fs.push(item)
        })
        console.log(fs)
        return fs
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .edit-btn {
        margin-right: 10px;
    }

    .info-table .el-checkbox__inner {
        border-radius: 50%;
    }
    .multipleSel .el-select__input{
        width: 40px !important;
        max-width: 100px !important;
        margin: 0 !important;
        border: 0 !important;
        background: none !important;
        outline: 0 !important;
        box-shadow: none !important;
    }
</style>



// WEBPACK FOOTER //
// src/pages/dsp/register/Company.vue